// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPage_container__2Fjgu"};